'use client';
import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { CancelRounded, DeleteForeverRounded } from '@mui/icons-material';
import { Profile } from '@/shared/i18n';
import { ProfileLoading, useProfileStore } from '../../stores/profile-store';

interface DeleteAccountDialogProps {
  dict: Profile['profile'];
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({
  dict,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const { isLoading: isLoadingStore } = useProfileStore();
  const isLoading = isLoadingStore === ProfileLoading.DELETE;

  const [isConfirmDeleteChecked, setIsConfirmDeleteChecked] = useState(false);

  const handleCloseDialog = () => {
    setIsConfirmDeleteChecked(false);
    onClose();
  };
  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={isOpen}
      onClose={handleCloseDialog}
      aria-labelledby="delete-account-dialog-title"
    >
      <DialogTitle id="delete-account-dialog-title" className="flex justify-between">
        <Typography variant="h5" component="h5">
          {dict.account_delete_dialog_title}
        </Typography>
        <CancelRounded className="text-action-divider" onClick={() => handleCloseDialog()} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body-500" color="textSecondary" marginBottom={2} component="p">
          {dict.account_delete_dialog_description}
        </Typography>
        <FormControlLabel
          required
          disabled={isLoading}
          control={
            <Checkbox
              checked={isConfirmDeleteChecked || isLoading}
              onChange={(e) => setIsConfirmDeleteChecked(e.target.checked)}
            />
          }
          label={<Typography variant="s2">{dict.account_delete_dialog_confirmation}</Typography>}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleCloseDialog()} color="primary">
          <Typography variant="button-m">{dict.account_delete_dialog_cancel}</Typography>
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={!isConfirmDeleteChecked || isLoading}
          color="error"
          type="submit"
          className="gap-1 shadow-none"
        >
          {isLoading ? (
            <CircularProgress size={12} color="inherit" />
          ) : (
            <>
              <DeleteForeverRounded className="h-[16px] w-[16px]" />
              <Typography variant="button-m">{dict.account_delete_dialog_submit}</Typography>
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountDialog;
